export default function isRedirectionPathnameValid(pathname: string) {
  // Exclude "/" and "/{locale}"
  if (pathname === "/" || (pathname.length === 3 && pathname.startsWith("/"))) {
    return false;
  }

  // Exclude sessionless screens
  if (
    pathname.includes("/login") ||
    pathname.includes("/register") ||
    pathname.includes("/confirm-email") ||
    pathname.includes("/reset-password") ||
    pathname.includes("/set-password") ||
    // auth-v2 account-collision screen. Lives outside the /login and
    // /register prefixes, so it needs its own entry.
    pathname.includes("/auth/conflict")
  ) {
    return false;
  }

  return true;
}
